// import hooks
import { useRef } from "react";
export const useSearchRefs = () => {
    const inputSearchRef = useRef(null);
    const wrapperRef = useRef(null);
    return { inputSearchRef, wrapperRef };
};
export default useSearchRefs;
